import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signOut } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB7V3Wb8FRGVC80kmnJl6EZYcd2zPgIVuE",
  authDomain: "csv-upload-app-38643.firebaseapp.com",
  projectId: "csv-upload-app-38643",
  storageBucket: "csv-upload-app-38643.firebasestorage.app",
  messagingSenderId: "229101593810",
  appId: "1:229101593810:web:df9376836fa2d1fae4790b",
  measurementId: "G-ZLZHHPYB40"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Firebase Auth
const auth = getAuth(app);

// Sign out function
const logoutUser = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Logout error:', error);
  }
};

export { db, auth, logoutUser };
